module.exports = __webpack_public_path__ + "static/media/iPhone14_4.1c7f06f9.png";